import { colors } from "assets/colors/colors";
import moment from "moment";
import z from "zod";

export const MEMBERSHIP_TEMPLATE_STATUS = {
  inactive: "inactive",
  active: "active",
  displayValue: (status) => {
    if (status === MEMBERSHIP_TEMPLATE_STATUS.active) {
      return "Active";
    } else if (status === MEMBERSHIP_TEMPLATE_STATUS.inactive) {
      return "Inactive";
    } else {
      return "Unknown";
    }
  },
  color: (status) => {
    if (status === MEMBERSHIP_TEMPLATE_STATUS.active) {
      return colors.success;
    } else if (status === MEMBERSHIP_TEMPLATE_STATUS.inactive) {
      return colors.redAlarm;
    }
  },
  values: () => [
    MEMBERSHIP_TEMPLATE_STATUS.active,
    MEMBERSHIP_TEMPLATE_STATUS.inactive,
  ],
};

export const membershipTemplateNameSchemaField = z
  .string()
  .trim()
  .min(1, { message: "Template name is required" })
  .max(100, { message: "Name must be less than 100 characters" });

export const membershipTemplateAmountSchemaField = z.preprocess(
  (value) => (typeof value === "number" ? value : -1),
  z.number().min(0, { message: "Default template amount is required" }),
);

export const membershipTemplateVisitsSchemaField = z.array(
  z.object({
    visitType: z.preprocess(
      (val) => val || "",
      z.string().min(1, { message: "Visit type is required" }),
    ),
    price: z.preprocess(
      (value) => (typeof value === "number" ? value : -1),
      z.number().min(0, { message: "Price is required" }),
    ),
  }),
);

export const membershipTemplateSchemaToJsonTranform = (value) => {
  return {
    name: value.name,
    price: value.amount,
    template_visits: value.visits.map((visit) => ({
      visit_type: visit.visitType,
      price: visit.price,
    })),
  };
};

export const membershipTemplateFromJson = (json) => {
  const sortedVisits = json.template_visits?.sort((a, b) =>
    a.name.localeCompare(b.name),
  );
  return {
    uuid: json.uuid,
    name: json.name,
    amount: json.price,
    status: json.status,
    visits: sortedVisits?.map((templateVisit) => ({
      visitType: templateVisit.visit_type,
      price: templateVisit.price,
    })),
    updatedAt: moment(json.updated_at),
  };
};
